import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlgoliaAnalyticsService } from '../../../shared/services/algolia-analytics/algolia-analytics.service';

@Injectable({
  providedIn: 'root',
})
export class TrendingScreensService {
  constructor(private algoliaAnalyticsService: AlgoliaAnalyticsService) {}

  public getTrendingScreens(): Observable<any> {
    return this.algoliaAnalyticsService.getTrendingHits();
  }
}
